import { PlaylistGenerator } from './PlaylistGenerator'
import React, {createContext, useContext, useEffect, useMemo, useRef, useState} from 'react';
import PlaylistGeneratorInfo from "./PlaylistGeneratorInfo";
import {Toast} from "primereact/toast";
import { MainHeader} from "./MainHeader";
import GeneratedPlaylist from "./GeneratedPlaylists";
import {ScrollTop} from "primereact/scrolltop";
import {AuthContext} from "../App";
import SpotifyConnectionInfo from "./SpotifyConnectionInfo";
import GeneratedPlaylistsInfo from "./GeneratedPlaylistsInfo";
import SpotifyConnection from "./SpotifyConnection";
import {useParams} from "react-router";
import {UserService} from "../services/UserService";
import {ErrorBoundary} from "react-error-boundary";
import {PlaylistManipulator} from "./PlaylistManipulator";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";

export const MainPageContext = createContext(null);

export default function MainPage() {
    // const [welcomeDialogVisible, setWelcomeDialogVisible] = useState(true);
    const [nrAddedPlaylists, setNrAddedPlaylists] = useState(0);
    const [spotifyApps, setSpotifyApps] = useState([]);
    const [spotifyUsers, setSpotifyUsers] = useState([]);
    const [spotifyAppOptions, setSpotifyAppOptions] = useState([]);
    const [showAMconnectDialog, setShowAMConnectDialog] = useState(false);

    const mainToast = useRef(null);
    const userservice = new UserService();

    // if an item with public: false is added ... the Menu has to be fixed!!!!
    const menuItemOptions = [
        {id: "plgenerator", displayname: "BTS Playlist Generator", public: true},
        {id: "playlisteditor", displayname: "BTS Playlist Editor", public: true},
        {id: "myplaylists", displayname: "My Playlists", public: true},
        {id: "spotifyusers", displayname: "My Spotify Users", public: true},
    ];
    const [currentMenuItem, setCurrentMenuItem] = useState({id:"unset"}); // 'BTS Playlist Generator'); // 'User'
    const [lastRefreshTime, setLastRefreshTime] = useState(null);

    const auth = useContext(AuthContext);

    let {spotifyInitializerPlaylist, editorInitializerPlaylist} = useParams()

    function setCurrentMenuItemFunc(menuItem) {
        sessionStorage.setItem("currentMenuItem", JSON.stringify(menuItem));
        setCurrentMenuItem(menuItem);
    }

    //startup effect
    useEffect( () => {
        let curMenItemIndex = JSON.parse(sessionStorage.getItem("currentMenuItem"))
        if(spotifyInitializerPlaylist){
            setCurrentMenuItem(menuItemOptions[0]); // means we come from /playlist
        } else if(editorInitializerPlaylist){
            setCurrentMenuItem(menuItemOptions[1]); // means path was /editor ..
        }else if(curMenItemIndex !== undefined && curMenItemIndex !== null && currentMenuItem.id !== curMenItemIndex.id) {
            setCurrentMenuItem(curMenItemIndex);  // use latest item, if path not defined
        } else {
            setCurrentMenuItem(menuItemOptions[0]);
        }
    }, []);

    // authentication effect
    useEffect(() => {

        if(auth?.isAuthenticated()) {
            userservice.getSpotifyData(auth?.getAccessToken()).then((resp) => {
                if (resp.status === 200) {
                    resp.json().then((data) => {
                        console.log("data length" + data.length);
                        setSpotifyApps(data.spotify_apps)
                        setSpotifyUsers(data.spotify_users)
                        setSpotifyAppOptions(data.spotify_app_slots)
                    })
                } else {
                    if (resp.status === 401) {
                        mainToast.current.show({
                            severity: 'error',
                            summary: 'Not authorized',
                            detail: 'Please, log in.',
                            life: 6000
                        })
                    } else {
                        mainToast.current.show({
                            severity: 'error',
                            summary: 'Data could not be retrieved',
                            detail: 'Please, try again!',
                            life: 6000
                        })
                    }

                }
            });
            return () => {};
        } else {
            //setCurrentMenuItem(menuItemOptions[0]);

            // mainToast.current.show(
            //     {   severity: "info",
            //         content: (props) => (
            //             <div>
            //                 Hi!<br/><br/>
            //                 This is a <b>playlist generator for BTS</b>, that I am currently developing.<br/><br/>
            //                 If you share with friends please use: <b>playlist.laramon.ch</b><br/><br/>
            //                 Thanks for trying it out, and if you have feedback please let me know :)<br/><br/>
            //                 <a href="https://x.com/LaraMo_7">LaraMo_7</a> on twix
            //             </div>
            //         ),
            //         style: {
            //             backgroundColor: '#beaae0', // Background of the toast container
            //             color: '#482980', // Text color of the toast
            //             borderLeft: '5px solid #482980' // Add a blue border
            //         },
            //         life: 3000 });
        }
    }, [auth, lastRefreshTime]);


    // AM Dialog
    useEffect(() => {
        if(!auth.isAMauthorized && !showAMconnectDialog){
            setShowAMConnectDialog(true);
        } else {
            setShowAMConnectDialog(false);
        }

    }, [auth.isAMauthorized]);

    function connectAM() {
        const music = window.MusicKit.getInstance();

        music.authorize().then(res =>{
            if(res != undefined){
                setShowAMConnectDialog(false);
                auth.setIsAMauthorized(true); // probably should move this to App.js
            }
        });
    }

    function incrementAddedPlaylist() {
        let _nrPladded = nrAddedPlaylists;
        setNrAddedPlaylists(_nrPladded+1);
    }

    // <ErrorBoundary fallback={<p>Something went wrong</p>}>

    const contextValue = useMemo(()=> ({
        setLastRefreshTime,
        setCurrentMenuItem,
        mainToast,
    }), [setLastRefreshTime, setCurrentMenuItem]);

    return (
        <MainPageContext value={contextValue}>
            <div className="layout-content-inner">
                <Toast ref={mainToast} position="top-right"  />
                <div hidden={currentMenuItem !== null}>Setting current Menu Item</div>

                <Dialog header={"Connecting to Apple Music"} style={{ width: '450px' }} visible={showAMconnectDialog} onHide={() => setShowAMConnectDialog(false)}>
                    <p>No Apple Music? Please check <a href="http://playlist.laramon.ch">playlist.laramon.ch</a> to generate spotify playlist.</p>

                    <p>In order to save playlists to Apple Music, you need to login with your Apple Id (connected to AM). The connection is saved in the browser.</p>
                    <p>To disconnect again, there are 2 options:
                        <ul>
                            <li>Click the apple logo in the top right corner (appears after successful connection).</li>
                            <li>Edit access in your apple music account: Apple Music -> Account -> Apps with Access (This app is called: BTS Playlist Generator)</li>
                        </ul>
                    </p>
                    <Button onClick={connectAM}>Connect to Apple Music</Button>
                </Dialog>


                <MainHeader menuItemOptions={menuItemOptions}
                            setCurrentMenuItem={setCurrentMenuItemFunc} currentMenuItem={currentMenuItem}
                />

                <div hidden={currentMenuItem.id !== 'plgenerator'}>
                    <PlaylistGeneratorInfo/>
                    <PlaylistGenerator getToken={auth?.getAccessToken} incrementPlaylistCounter={incrementAddedPlaylist} spotifyUsers={spotifyUsers} initPlaylist={spotifyInitializerPlaylist}/>
                </div>

                <div hidden={currentMenuItem.id !== 'myplaylists'}>
                    <GeneratedPlaylistsInfo/>
                    <div hidden={!auth?.isAuthenticated()}>
                        <GeneratedPlaylist nrAddedPlaylists={nrAddedPlaylists}/>
                    </div>
                </div>

                <div hidden={ currentMenuItem.id !== 'spotifyusers' }>
                    <SpotifyConnectionInfo/>
                    <div hidden={!auth?.isAuthenticated()}>
                            <SpotifyConnection
                                spotifyUsers={spotifyUsers} setSpotifyUsers={setSpotifyUsers}
                                spotifyApps={spotifyApps} setSpotifyApps={setSpotifyApps}
                                spotifyAppOptions={spotifyAppOptions} setSpotifyAppOptions={setSpotifyAppOptions}
                            />
                    </div>
                </div>

                <div hidden={currentMenuItem.id !== 'playlisteditor' }>
                    <PlaylistManipulator initPlaylist={editorInitializerPlaylist} spotifyUsers={spotifyUsers} incrementPlaylistCounter={incrementAddedPlaylist}/>
                </div>

                <ScrollTop className={"bg-highlight"} icon="pi pi-arrow-up text-base" />
            </div>
        </MainPageContext>
        )
}